import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
  ApiPostMultipart,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';
export const state = {
  data: {
    title: 'Generate Faktur Pajak',
    form_title: 'Form Generate Faktur',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Generate Faktur',
        href: '/adm/fin/faktur-pajak/generate-faktur',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'created_at',
    sortDesc: false,
    fields_generate: [
      {
        key: 'trans_date',
        label: 'Tanggal',
      },
      {
        key: 'trans_code',
        label: 'Trans No',
      },
      {
        key: 'trans_type',
        label: 'Type',
      },
      {
        key: 'trans_principle',
        label: 'Principle',
      },
      {
        key: 'trans_currency',
        label: 'Currency',
      },
      {
        key: 'trans_nominal',
        label: 'Nominal',
      },
    ],
    fields: [
      {
        key: 'start_date',
        label: 'Start Date',
        sortable: true,
      },
      {
        key: 'end_date',
        label: 'End Date',
        sortable: true,
      },
      {
        key: 'prefix_no',
        label: 'No Prefix',
        sortable: true,
      },
      {
        key: 'start_number',
        label: 'Start Number',
        sortable: true,
      },
      {
        key: 'end_number',
        label: 'End Number',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    detail: false,
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeFaktur(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchFaktur(context, params = null) {
    let result = await ApiGetRequest(`fin/faktur`, params);
    return !result.error ? result.data.object : [];
  },

  async uploadDocument({ commit, state }, payload) {
    commit('changeFaktur', {
      loadingUpload: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/upload-document`, payload);
    commit('changeFaktur', {
      loadingUpload: false,
    });

    if (!result.error) {
      let doc_files = data.form.doc_files || [];
      doc_files.push(result.data.object);

      commit('changeFaktur', {
        form: {
          ...data.form,
          doc_files,
        },
      });
    }
  },

  async uploadDocumentFaktur({ commit, state, dispatch }) {
    commit('changeFaktur', {
      loading: true,
    });

    let data_form = state.data.form;
    let result = await ApiPostRequest(`fin/faktur/upload-faktur`, data_form);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async getFakturTransaksi({ commit, state }) {
    commit('changeFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`fin/faktur/show-trans`, params);
    commit('changeFaktur', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListFaktur({ commit, state }) {
    commit('changeFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/faktur`, params);
    commit('changeFaktur', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getDetailFaktur({ commit, state }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/faktur/${payload.id}`);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      commit('changeFaktur', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async createGenerateFaktur({ commit, state, dispatch }) {
    commit('changeFaktur', {
      loading: true,
    });

    let data_form = state.data.form;
    data_form.start_date =
      data_form.date && data_form.date.length > 0 && data_form.date[0]
        ? moment(data_form.date[0]).format('YYYY-MM-DD')
        : '';
    data_form.end_date =
      data_form.date && data_form.date.length > 0 && data_form.date[1]
        ? moment(data_form.date[1]).format('YYYY-MM-DD')
        : '';

    let result = await ApiPostRequest(`fin/faktur/generate-faktur`, data_form);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateFaktur({ commit, state, dispatch }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/faktur/${payload.id}`,
      state.data.form
    );

    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteFaktur({ commit, dispatch }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/faktur/${payload.id}`);
    commit('changeFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async downloadFaktur({ commit }, payload = null) {
    commit('changeFaktur', {
      loading: true,
    });

    let result = await ApiBlobGetRequest(
      `fin/faktur/download-excel/${payload ? payload.id_faktur_coretax : ''}`
    );

    if (result.error) {
      commit('changeFaktur', {
        loading: false,
      });

      return false;
    } else {
      commit('changeFaktur', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = result.data;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_coretax.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },
};
